import * as t from 'io-ts'
import { Left } from 'fp-ts/lib/Either'
import md5 from 'md5'

export function wait (ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function hash (text: string): string {
  return md5(text)
}

export function getQueryParams<T = string> (queryString: string): Record<string, T> {
  return Object.fromEntries(queryString.slice(1).split('&').map(pair => pair.split('=')))
}

export function parseDecodeError (response: Left<t.Errors>): string | undefined {
  let error
  response.left.forEach(a => {
    const keys = a.context.map(a => a.key).reverse()
    const key = keys.find(k => isNaN(parseInt(k))) || keys[0]
    if (a.value === undefined) {
      error = `Undefined ${key}`
    } else {
      const val = typeof a.value === 'object' ? JSON.stringify(a.value) : a.value
      error = `Invalid ${key}: ${val}`
    }
  })
  return error
}
